import { useFormContext, useWatch } from 'react-hook-form';

import { VariantColorButton, VariantFieldset } from '@libs/shared-ui';

import type { FormFields } from '@/entities/purchase-form';

import { ColorPalette } from './colorPaletteTypes';

type ColorsProps = {
    colors: string[];
};

export const Colors = ({ colors }: ColorsProps) => {
    const { register } = useFormContext<FormFields>();
    const currentColor: string | undefined = useWatch({ name: 'personalization.colorStyle' });

    const colorPalette = colors.map(color => ({
        label: color,
        value: color,
        color: ColorPalette[color as keyof typeof ColorPalette],
    }));

    return (
        <VariantFieldset legendKey="Thread color" legendValue={currentColor ?? 'Select color'}>
            {colorPalette.map(({ label, value, color }) => (
                <VariantColorButton
                    key={color}
                    label={label}
                    value={value}
                    colors={[color]}
                    isChecked={value === currentColor}
                    {...register('personalization.colorStyle')}
                />
            ))}
        </VariantFieldset>
    );
};
